import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { DatePicker, Select } from "antd";

import "./loginmodal.scss";
import SvgCloseRound from "../../icons/SvgCloseRound";
import { useDispatch, useSelector, connect } from "react-redux";
import { submitUserMiddleWare } from "./store/loginMiddleware";
import { setLoader } from "../../redux/store/commonReducer";
import SvgAstroLg from "../../icons/SvgAstroLg";
import { toast } from "react-toastify";
import { isEmpty } from "../../utils/validators";
import dayjs from "dayjs";
import { isValidEmail } from "../../utils/util";
import { getCityMiddleWare } from "../../pages/Prompt/store/promptMiddleware";
import { convertIsActiveToString } from "../../pages/horoscope/HoroscopeScreen";
import { toLowerCaseKeys } from "../../utils/util";

const initialState = {
  userName: "",
  email: "",
  dob: null,
};

function mapStateToProps({
  cityReducers,
}) {
  return {
    locationList: cityReducers.data,
  };
}

const LoginDetails = ({ visible, onclose, locationList = [] }) => {
  const [{ userName, email, dob }, setValue] = useState(initialState);
  const [detailsValue, setDetailsValue] = useState({location: "",});
  const dispatch = useDispatch();
  const _L = (action) => {
    return action
      .then(() => dispatch(setLoader(true)))
      .finally(() =>
        setTimeout(() => {
          dispatch(setLoader(false));
        }, 400)
      );
  };

  const { mobileData } = useSelector(({ loginUserReducers }) => {
    return {
      mobileData: loginUserReducers.data,
    };
  });

  const onChange = (event) => {
    const { name, value } = event.target;
    setValue((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    dispatch(setLoader(true));
    const parsedDate = dayjs(dob, "DD/MM/YY");

    const formattedDate = parsedDate.format("YYYY-MM-DD");
    const payload = {
      memberType: 3,
      userName: userName,
      mobileNo: mobileData?.mobileNumber,
      email: email,
      profileUrl: "",
      dob: formattedDate,
      location: detailsValue?.location,
      platform: "android",
      registration_token: "",
    };
    dispatch(submitUserMiddleWare(payload))
      .then((res) => {
        if (res.payload?.message === "Success") {
          toast.success(res.payload.alert, {
            position: "top-center",
          });
          const loginDetails = JSON.stringify(res.payload);
          localStorage.setItem("user", loginDetails);
          localStorage.setItem("isLoggedIn", true);
          onclose();
        } else if (res.payload?.response?.data?.message === "Fail") {
          toast.error(res.payload?.response?.data?.alert, {
            position: "top-center",
          });
        }
      })
      .finally(() => dispatch(setLoader(false)));
  };
    useEffect(() => {
        getLocationList();
    }, []);

  const getLocationList = () => {
    _L(dispatch(getCityMiddleWare()));
  };

  // Ensure locationList is always an array before processing
  const safeLocationList = Array.isArray(locationList) ? locationList : [];
  const newDataLocationList = convertIsActiveToString(
    toLowerCaseKeys(safeLocationList)
  );

  const getValue = (data, id) => {
    return data?.filter((list) => list.key === id)[0];
  };

  return (
    <Modal
      footer={null}
      centered
      open={visible}
      width={462}
      closeIcon={<SvgCloseRound />}
      onCancel={() => onclose()}
    >
      <div className="login-modal-container">
        <div className="login-details-header">
          <SvgAstroLg />
          <h2>Welcome to AstroCure</h2>
        </div>

        <div className="login-detail">
          <div className="input-field">
            <label htmlFor="userName">What’s your Full name?</label>
            <input
              type="text"
              placeholder="Enter your Full name"
              name="userName"
              value={userName}
              onChange={onChange}
            />
          </div>
          <div className="input-field">
            <label htmlFor="dob">What’s your Date of Birth?</label>
            <DatePicker
              disabledDate={(current) => current && current > dayjs()}
              format={"DD/MM/YY"}
              placeholder="Enter Birth Place"
              onChange={(_, dateString) =>
                setValue((prev) => ({ ...prev, dob: dateString }))
              }
            />
          </div>
          <div className="input-field location-div">
            <label htmlFor="location">Location</label>
            <Select 
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0 ||
                option.props.value.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
              }
              showSearch
              className={"select-forum"}
              onChange={(val) => {
                setDetailsValue((prev) => ({
                  ...prev,
                  ["location"]: val,
                }));
              }}
              value={
                getValue(newDataLocationList, detailsValue?.location)?.label
                  ? getValue(newDataLocationList, detailsValue?.location)?.label
                  : ""
              }
              defaultValue="lucy"
              style={{ width: 120 }}
            >
              {newDataLocationList.map((list) => {
                return (
                  <Select.Option value={list.key}>{list.label}</Select.Option>
                );
              })}
            </Select>
          </div>
          <div className="input-field">
            <label htmlFor="email">What’s your Email id?</label>
            <input
              type="email"
              placeholder="Enter your email id"
              name="email"
              value={email}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="login-details-footer">
          <button
            style={{
              opacity:
                (!isEmpty(email) && !isValidEmail(email)) ||
               // isEmpty(email) ||
                isEmpty(dob) ||
                isEmpty(userName)
                  ? 0.5
                  : 1,
            }}
            disabled={
               (!isEmpty(email) && !isValidEmail(email)) ||
             // isEmpty(email) ||
              isEmpty(dob) ||
              isEmpty(userName)
            }
            className="primary-btn form-btn w-full"
            type="button"
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
};
export default connect(mapStateToProps)(LoginDetails);
